/** @format */
export const AVAILABLE_TYPES = {
  AVAILABLE: "AVAILABLE",
  UNAVAILABLE: "UNAVAILABLE"
};
